import { TStep1Data } from "@/models/msc.model";
import { OnboardingStep, TUser } from "@/models/user.model";
import axios from "@utils/axios-instance";

const updateOnboarding = async (data: { currentStep: OnboardingStep }): Promise<TUser["onboarding"]> => {
  const response = await axios.patch("/onboarding", { ...data, lastCompletedStep: data.currentStep });
  return response.data;
};

export const submitStep1 = async (data: TStep1Data) => {
  await axios.post("/onboarding/step-1", data);
};

export const skipStep = async (step: number) => {
  await axios.patch(`/onboarding/skip/${step}`);
};

export const submitStep3 = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  await axios.post(`/onboarding/step-3/`, formData);
};

export const submitStep4 = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  await axios.post(`/onboarding/step-4/`, formData);
};

export const submitStep5 = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  await axios.post(`/onboarding/step-5/`, formData);
};

export default {
  updateOnboarding,
  skipStep,
  submitStep1,
  submitStep3,
  submitStep4,
  submitStep5,
};
